var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-2"},[_c('vue-content-loading',{attrs:{"width":750,"height":400}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }